import { getRouteApi } from "@tanstack/react-router"
import { z } from "zod"
import { SHOPS } from "./data"
import { RANGES } from "./timeline"

export const VIEWS = ["crew", "work-orders"] as const

export type View = (typeof VIEWS)[number]

export const manpowerSearchSchema = z.object({
  view: z.enum(VIEWS).optional().catch(undefined),
  range: z.enum(RANGES).optional().catch(undefined),
  start: z.number().int().optional().catch(undefined),
  quoted: z.boolean().optional().catch(undefined),
  capacity: z.boolean().optional().catch(undefined),
  search: z.string().optional().catch(undefined),
  shops: z.array(z.enum(SHOPS)).optional().catch(undefined),
})

export type ManpowerSearch = z.infer<typeof manpowerSearchSchema>

export function viewLabel(view: View): string {
  switch (view) {
    case "crew":
      return "Crew"
    case "work-orders":
      return "Work orders"
  }
}

const manpowerRoute = getRouteApi("/_layout/manpower/")

export function useManpowerSearch(): ManpowerSearch {
  return manpowerRoute.useSearch()
}

export function useUpdateManpowerSearch(): (
  patch: Partial<ManpowerSearch>,
) => void {
  const navigate = manpowerRoute.useNavigate()
  return (patch) =>
    navigate({
      search: (previous) => ({ ...previous, ...patch }),
      replace: true,
    })
}
